// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type AllConfigurationsDimensionsQueryVariables = Types.Exact<{
  productOfferingIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type AllConfigurationsDimensionsQuery = { __typename?: 'Query', potentialBidPlanDimensions: Array<{ __typename?: 'PotentialBidPlanDimensionResult', id: string, kind: Types.PotentialBidPlanDimensionKind, displayName: string, type?: { __typename?: 'GlobalOptionType', id: string } | null | undefined, options: Array<{ __typename?: 'GlobalOption', id: string, name: string }> }> };

export type AllConfigurationsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.CostConfigurationSummariesFilter>;
  orderBy?: Types.InputMaybe<Types.CostConfigurationSummaryOrderBy>;
  page?: Types.InputMaybe<Types.PageFilter>;
}>;


export type AllConfigurationsQuery = { __typename?: 'Query', costConfigurationSummaries: { __typename?: 'CostConfigurationSummariesPage', entities: Array<{ __typename?: 'CostConfigurationSummary', id: string, totalCostInCents: number, totalPriceInCents: number, costPerSellableSqftInCents: number, contingencyInCents: number, indirectCostInCents: number, directCostInCents: number, provisionalCostsInCents: number, provisionalPercentage: number, softCostInCents: number, productOffering: { __typename?: 'ProductOffering', contingencyMarkupPercentage?: number | null | undefined, id: string, name: string }, pinnedOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string } }>, programData: { __typename?: 'ProgramData', id: string, sellableSqft?: number | null | undefined } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean } } };

export type AllConfigurations_CostConfigurationSummaryFragment = { __typename?: 'CostConfigurationSummary', id: string, totalCostInCents: number, totalPriceInCents: number, costPerSellableSqftInCents: number, contingencyInCents: number, indirectCostInCents: number, directCostInCents: number, provisionalCostsInCents: number, provisionalPercentage: number, softCostInCents: number, productOffering: { __typename?: 'ProductOffering', contingencyMarkupPercentage?: number | null | undefined, id: string, name: string }, pinnedOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string } }>, programData: { __typename?: 'ProgramData', id: string, sellableSqft?: number | null | undefined } };

export type AllConfigurations_PotentialBidPlanDimensionResultFragment = { __typename?: 'PotentialBidPlanDimensionResult', id: string, kind: Types.PotentialBidPlanDimensionKind, displayName: string, type?: { __typename?: 'GlobalOptionType', id: string } | null | undefined, options: Array<{ __typename?: 'GlobalOption', id: string, name: string }> };

export const AllConfigurations_CostConfigurationSummaryFragmentDoc = gql`
    fragment AllConfigurations_CostConfigurationSummary on CostConfigurationSummary {
  id
  totalCostInCents
  totalPriceInCents
  costPerSellableSqftInCents
  contingencyInCents
  indirectCostInCents
  directCostInCents
  provisionalCostsInCents
  provisionalPercentage
  softCostInCents
  productOffering {
    ...Named
    contingencyMarkupPercentage
  }
  pinnedOptions {
    id
    name
    type {
      id
    }
  }
  programData {
    id
    sellableSqft
  }
}
    ${NamedFragmentDoc}`;
export const AllConfigurations_PotentialBidPlanDimensionResultFragmentDoc = gql`
    fragment AllConfigurations_PotentialBidPlanDimensionResult on PotentialBidPlanDimensionResult {
  id
  kind
  displayName
  type {
    id
  }
  options {
    ...Named
  }
}
    ${NamedFragmentDoc}`;
export const AllConfigurationsDimensionsDocument = gql`
    query AllConfigurationsDimensions($productOfferingIds: [ID!]!) {
  potentialBidPlanDimensions(productOfferingIds: $productOfferingIds) {
    ...AllConfigurations_PotentialBidPlanDimensionResult
  }
}
    ${AllConfigurations_PotentialBidPlanDimensionResultFragmentDoc}`;

/**
 * __useAllConfigurationsDimensionsQuery__
 *
 * To run a query within a React component, call `useAllConfigurationsDimensionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllConfigurationsDimensionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllConfigurationsDimensionsQuery({
 *   variables: {
 *      productOfferingIds: // value for 'productOfferingIds'
 *   },
 * });
 */
export function useAllConfigurationsDimensionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllConfigurationsDimensionsQuery, AllConfigurationsDimensionsQueryVariables> & ({ variables: AllConfigurationsDimensionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllConfigurationsDimensionsQuery, AllConfigurationsDimensionsQueryVariables>(AllConfigurationsDimensionsDocument, options);
      }
export function useAllConfigurationsDimensionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllConfigurationsDimensionsQuery, AllConfigurationsDimensionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllConfigurationsDimensionsQuery, AllConfigurationsDimensionsQueryVariables>(AllConfigurationsDimensionsDocument, options);
        }
// @ts-ignore
export function useAllConfigurationsDimensionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AllConfigurationsDimensionsQuery, AllConfigurationsDimensionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllConfigurationsDimensionsQuery, AllConfigurationsDimensionsQueryVariables>;
export function useAllConfigurationsDimensionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllConfigurationsDimensionsQuery, AllConfigurationsDimensionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllConfigurationsDimensionsQuery | undefined, AllConfigurationsDimensionsQueryVariables>;
export function useAllConfigurationsDimensionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllConfigurationsDimensionsQuery, AllConfigurationsDimensionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AllConfigurationsDimensionsQuery, AllConfigurationsDimensionsQueryVariables>(AllConfigurationsDimensionsDocument, options);
        }
export type AllConfigurationsDimensionsQueryHookResult = ReturnType<typeof useAllConfigurationsDimensionsQuery>;
export type AllConfigurationsDimensionsLazyQueryHookResult = ReturnType<typeof useAllConfigurationsDimensionsLazyQuery>;
export type AllConfigurationsDimensionsSuspenseQueryHookResult = ReturnType<typeof useAllConfigurationsDimensionsSuspenseQuery>;
export type AllConfigurationsDimensionsQueryResult = ApolloReactCommon.QueryResult<AllConfigurationsDimensionsQuery, AllConfigurationsDimensionsQueryVariables>;
export const AllConfigurationsDocument = gql`
    query AllConfigurations($filter: CostConfigurationSummariesFilter, $orderBy: CostConfigurationSummaryOrderBy, $page: PageFilter) {
  costConfigurationSummaries(filter: $filter, orderBy: $orderBy, page: $page) {
    entities {
      ...AllConfigurations_CostConfigurationSummary
    }
    pageInfo {
      hasNextPage
    }
  }
}
    ${AllConfigurations_CostConfigurationSummaryFragmentDoc}`;

/**
 * __useAllConfigurationsQuery__
 *
 * To run a query within a React component, call `useAllConfigurationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllConfigurationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllConfigurationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useAllConfigurationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllConfigurationsQuery, AllConfigurationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllConfigurationsQuery, AllConfigurationsQueryVariables>(AllConfigurationsDocument, options);
      }
export function useAllConfigurationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllConfigurationsQuery, AllConfigurationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllConfigurationsQuery, AllConfigurationsQueryVariables>(AllConfigurationsDocument, options);
        }
// @ts-ignore
export function useAllConfigurationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AllConfigurationsQuery, AllConfigurationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllConfigurationsQuery, AllConfigurationsQueryVariables>;
export function useAllConfigurationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllConfigurationsQuery, AllConfigurationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllConfigurationsQuery | undefined, AllConfigurationsQueryVariables>;
export function useAllConfigurationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllConfigurationsQuery, AllConfigurationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AllConfigurationsQuery, AllConfigurationsQueryVariables>(AllConfigurationsDocument, options);
        }
export type AllConfigurationsQueryHookResult = ReturnType<typeof useAllConfigurationsQuery>;
export type AllConfigurationsLazyQueryHookResult = ReturnType<typeof useAllConfigurationsLazyQuery>;
export type AllConfigurationsSuspenseQueryHookResult = ReturnType<typeof useAllConfigurationsSuspenseQuery>;
export type AllConfigurationsQueryResult = ApolloReactCommon.QueryResult<AllConfigurationsQuery, AllConfigurationsQueryVariables>;